export default __webpack_public_path__ + "static/media/nurten2.b6d8b540.jpg";